import { render, staticRenderFns } from "./ImportPrintInformationForm.vue?vue&type=template&id=28c2bfab&scoped=true"
import script from "./ImportPrintInformationForm.vue?vue&type=script&lang=ts"
export * from "./ImportPrintInformationForm.vue?vue&type=script&lang=ts"
import style0 from "./ImportPrintInformationForm.vue?vue&type=style&index=0&id=28c2bfab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2bfab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c2bfab')) {
      api.createRecord('28c2bfab', component.options)
    } else {
      api.reload('28c2bfab', component.options)
    }
    module.hot.accept("./ImportPrintInformationForm.vue?vue&type=template&id=28c2bfab&scoped=true", function () {
      api.rerender('28c2bfab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/components/ImportPrintInformationForm.vue"
export default component.exports